
 jQuery(document).ready(function($) {
  
    //Event Handlers
   $('.banner-slideshow').slick({
	  arrows: false,
    centerPadding: "0px",
    dots: true,
    slidesToShow: 1,
    infinite: false
});
 });



  const videoPlayer = document.getElementById('videoPlayer');
    const playButton = document.getElementById('playButton');
const videoContent = document.getElementById('videoContent');
const videoOverlay = document.getElementById('videoOverlay');
    playButton.addEventListener('click', () => {
      if (videoPlayer.paused) {
        videoPlayer.play();
    
        playButton.style.display = 'none';
          videoContent.style.display = 'none'; 
      videoOverlay.style.display = 'none';
         
      } else {
        videoPlayer.pause();
        playButton.style.display = 'block';
           videoContent.style.display = 'block';
      
      }
    });